import { FC, useEffect, useState } from "react"
import image from '../../../assets/images/contaCriada.png'
import './success.css'
import { cpfCnpjNoMask } from "../../../functions/mask"
import api from "../../../services/api"
import { usePluginspace } from "../../../hooks/usePluginspace"
import { Loading } from "../../../components/Loading"
import { CardCustomer } from "../../../components/CardCustomer/cardCustomer"
import { UserIcon } from "../../../components/MenuIcons/UserIcon"
import { ChrevonRightIcon } from "../../../components/MenuIcons/ChevrotRight"
import { GearIcon } from "../../../components/MenuIcons/GearIcon"
import { LightIcon } from "../../../components/MenuIcons/LightIcon"
import { StarIcon } from "../../../components/MenuIcons/StarIcon"
import { GiftIcon } from "../../../components/MenuIcons/GiftIcon"
import { useNavigate, useParams } from "react-router-dom"


type Options = {
    icon: string,
    title: string,
    subtitle: string,
    route: string,

}

type Route = {
    name: string,
    options: Options[]
}


const SuccessPage: FC = () => {

    const { pluginspace_id } = useParams();
    const navigate = useNavigate();
    const routes: Route[] = [
        {
            name: 'Minha conta',
            options: [
                {
                    icon: 'user',
                    title: 'Informações pessoais',
                    subtitle: 'Confira seus dados cadastrais',
                    route: `/${pluginspace_id}/auth`
                },
                {
                    icon: 'gear',
                    title: 'Configuração da conta',
                    subtitle: 'Preferências de contato e privacidade',
                    route: `/${pluginspace_id}/auth`
                },
                {
                    icon: 'gear',
                    title: 'Alterar senha',
                    subtitle: 'Atualização de senha',
                    route: `/${pluginspace_id}/auth`
                },
                {
                    icon: 'light',
                    title: 'Endereços',
                    subtitle: 'Endereços cadastrados',
                    route: `/${pluginspace_id}/auth`
                }
            ]

        },
        {
            name: 'Compras',
            options: [
                {
                    icon: 'gift',
                    title: 'Meus Pedidos',
                    subtitle: 'Acompanhe suas compras',
                    route: `/${pluginspace_id}/auth`
                },
                {
                    icon: 'star',
                    title: 'Produtos favoritos',
                    subtitle: 'Confira sua lista de favoritos',
                    route: `/${pluginspace_id}/auth`
                }
            ]

        }
    ]

    const [account, setAccount] = useState({
        name: '',
        email: '',
        cpf: ''
    })
    const [loading, setLoading] = useState(true);
    const { getToken } = usePluginspace();

    const getCustomer = async () => {

        setLoading(true);
        const ppLS = JSON.parse(localStorage.getItem('payload')!)
        const cpf = cpfCnpjNoMask(ppLS.doc)


        await api
            .post(
                `/api/customer/filter`,
                {
                    cpf: cpf,
                },
                {
                    headers: {
                        Authorization: `Bearer ${await getToken()}`,
                    },
                }
            )
            .then(async (response: any) => {
                setLoading(false);
                if (response.data.data.length > 0) {
                    const data = response.data.data[0];

                    const payload = {
                        name: data.name,
                        email: data.email,
                        cpf: data.doc
                    }
                    setAccount(payload)

                } else {
                    //clearCustomer();
                }
            })
            .catch((err: any) => {
                //  clearCustomer();
                setLoading(false);
                console.log(err);
            });
    }

    const returnIcon = (value: string) => {

        switch (value) {
            case 'user':
                return <UserIcon />
            case 'gear':
                return <GearIcon />
            case 'light':
                return <LightIcon />
            case 'star':
                return <StarIcon />
            case 'gift':
                return <GiftIcon />
        }

    }

    useEffect(() => {
        getCustomer()
    }, [])


    return (
        <div className="contentSuccess">
            {loading ? (
                <div style={{
                    width: '100%',
                    height: 'calc(100vh)',
                    zIndex: "100",
                    position: "absolute",
                    left: '0',
                    top: "0"
                }}>
                    <Loading
                        type="spinningBubbles"
                        color="#FFF"
                        width={64}
                        height={64}
                    />
                </div>
            ) : (
                <>
                    <div className="successImage">
                        <img src={image} alt="Logo" />
                    </div>
                    <div className="successText">
                        <h3>Sua conta foi criada!</h3>
                        <span>Agora você pode aproveitar todos os benefícios do sistema e acompanhar os seus pedidos.</span>
                    </div>


                    <div>
                        <CardCustomer name={account.name} email={account.email} cpf={account.cpf} />
                    </div>

                    <div className="infoGeral">

                        {routes.map(opc => (
                            <div className="cardInfoOption">
                                <div className="cardHeader">
                                    <h3 className="InfoName">{opc.name}</h3>
                                </div>
                                {opc.options.map(option => (
                                    <div className="info">
                                        <div className="icon">
                                            {
                                                returnIcon(option.icon)
                                            }
                                        </div>
                                        <div className="header">
                                            <h4>{option.title}</h4>
                                            <span>{option.subtitle}</span>
                                        </div>
                                        <div className="icon">
                                            <ChrevonRightIcon action={() => navigate(option.route)} />
                                        </div>
                                    </div>
                                ))

                                }

                            </div>
                        ))

                        }
                    </div>




                </>
            )}
        </div>
    )
}

export {
    SuccessPage
}